/** A single client-supplied custom field value. */
export type CustomFieldValue = string | number | string[];

/** Datetime custom fields — epoch ms as a number or numeric/ISO date string. */
export type CustomFieldDateTimeValue = string | number;

/** Client-supplied values keyed by custom field id (e.g. `_c_6a436c1244764c9d4a6ce2fc`). */
export type CustomFieldValueMap = Record<string, CustomFieldValue>;

/** Stable empty map for hooks when client omits customFieldValues. */
export const EMPTY_CUSTOM_FIELD_VALUE_MAP: CustomFieldValueMap = {};
